import {
  GET_AUDIT_PLANS_SUCCESS,
  GET_AUDIT_PLAN_BY_ID_SUCCESS,
  AUDIT_PLAN_IS_LOADING,
} from "./constants"

const initialState = {
  auditPlans: [],
  auditPlanById: {},
  auditPlanIsLoading: true,
}

function dataAuditPlansReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_AUDIT_PLANS_SUCCESS:
      return {
        ...state,
        auditPlans: payload,
      }
    case GET_AUDIT_PLAN_BY_ID_SUCCESS:
      return {
        ...state,
        auditPlanById: payload,
      }
    case AUDIT_PLAN_IS_LOADING:
      return {
        ...state,
        auditPlanIsLoading: payload,
      }
    default:
      return state
  }
}

export default dataAuditPlansReducer
